import { useClientPortalPublicData } from '../../hooks'

export const useVisaBulletin = () => {
  const { dataClientPortalPublic } = useClientPortalPublicData()

  const visaBulletinData = dataClientPortalPublic?.visaBulletin
  const visaBulletinTrendData = dataClientPortalPublic?.visaBulletinTrend
  const priorityDate = dataClientPortalPublic?.caseInfo.priorityDate

  return {
    visaBulletinData,
    visaBulletinTrendData,
    priorityDate,
  }
}
